import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import Done from 'material-ui/svg-icons/action/done'
import { FormattedMessage } from 'react-intl'
import { FooterText, HeaderBackground, Instructions, SendAgainText, SentText } from './styles'
import { Link } from 'react-router-dom'
import images from '../../config/images'

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      emailError: false,
      hasError: true,
    }
  }
  handleChange = e => {
    e.preventDefault()
    const emailFilter = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({ email: e.target.value })
    if (this.state.email.length > 0) {
      if (!emailFilter.test(this.state.email)) {
        this.setState({
          emailError: <FormattedMessage id="signUp.emailError" />,
          hasErrors: true
        });
      }
      else {
        this.setState({ emailError: false, hasError: false })
      }
    }
    else {
      this.setState({ emailError: <FormattedMessage id="login.requiredField" />, hasError: true })
    }
  }
  handleSubmit = e => {
    e.preventDefault()
    if (!this.state.hasError) {
      const { email } = this.refs
      this.props.resetPassword(email.getValue())
    }
  }

  componentWillUnmount() {
    this.props.setShouldResetPassword(false)
  }

  render() {
    const {shouldResetPassword} = this.props
    if (shouldResetPassword) {
      return (
        <div>
          <HeaderBackground>
            <div className="pl4 pr4 pt3 pb3 flex justify-center items-center">
              <Done color="#fff" className="mr2"/>
              <SendAgainText>
                <FormattedMessage id="forgotPassword.sent"/>
                <Link
                  to={'/forgot-password'}
                  style={{color: '#fff'}}
                >
                  <FormattedMessage id="forgotPassword.sendAgain"/>
                </Link>
              </SendAgainText>
            </div>
          </HeaderBackground>
          <div className="pa4">
            <div className="flex justify-center items-center mb4">
              <img src={images.stars} alt="stars"/>
            </div>
            <div className="tc">
              <div className="mb3">
                <SentText>
                  <FormattedMessage id="forgotPassword.successLine1"/>
                </SentText>
                <SentText>
                  <FormattedMessage id="forgotPassword.successLine2"/>
                </SentText>
              </div>
              <FooterText>
                <FormattedMessage id="forgotPassword.checkSpam"/>
              </FooterText>
            </div>
          </div>
        </div>
      )
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <div>
          <Instructions>
            <FormattedMessage id="forgotPassword.resetByEMail"/>
          </Instructions>
        </div>
        <div>
          <TextField
            className="mb5"
            hintText="abc@abc.com"
            floatingLabelText={<FormattedMessage id="login.emailLable"/>}
            type="email"
            fullWidth
            ref="email"
            onChange={this.handleChange}
            value={this.state.email}
            onBlur={this.handleChange}
            errorText={
              this.state.emailError
            }
          />
          <div className="flex justify-end">
            <RaisedButton
              disabled={this.state.hasError}
              type="submit"
              backgroundColor="#45CE90"
              labelColor="#fff"
              label={<FormattedMessage id="forgotPassword.buttonLabel" />}
            />
          </div>
        </div>
      </form>
    )
  }
}

export default ForgotPasswordForm



// WEBPACK FOOTER //
// src/components/ForgotPassword/ForgotPassword.js